module.exports = __webpack_public_path__ + "img/Best Wishes.de6ea7ac.png";